<template>
  <div>
    <PFRow :label="$pgettext('contract.create.label','Name')" size="12x12">
      <CInput v-model="form.name" placeholder="Name"/>
    </PFRow>
    <PFRow :label="$pgettext('contract.create.label','Qty')" size="12x12">
      <CInput v-model="form.qty" placeholder="Qty"/>
    </PFRow>
    <PFRow :label="$pgettext('contract_manager.label', 'Currency')" size="12x12">
      <CurrencySelect :value="form.currency" @input="form.currency = $event"/>
    </PFRow>
    <PFRow :label="$pgettext('contract_manager.label', 'Is SaaS')">
      <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_saas" @input="onSaasToggle"/>
    </PFRow>
    
    <template v-if="form.is_saas">
      <!-- SaaS Contract Fields -->
      <PFRow :label="$pgettext('contract_manager.label', 'Plan Category')" size="12x12">
        <PSelectKeyValue :options="planCategoryOptions" :value.sync="form.plan_category" placeholder="Select Plan Category" @input="onPlanCategoryChange"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Base Plan')" size="12x12">
        <PSelectKeyValue :options="basePlanOptions" :value.sync="form.base_plan" placeholder="Select Base Plan" :disabled="!form.plan_category"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Is Subscription')">
        <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_subscription"/>
      </PFRow>
      <template v-if="form.is_subscription">
        <PFRow :label="$pgettext('contract_manager.label', 'Num Photo Included')">
          <CInput v-model="form.settings.num_photo_included" type="number"/>
        </PFRow>
        <PFRow :label="$pgettext('contract_manager.label', 'Num Max Photo')">
          <CInput v-model="form.settings.num_max_photo" type="number"/>
        </PFRow>
        <PFRow :label="$pgettext('contract_manager.label', 'Is Promo')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.settings.is_promo"/>
        </PFRow>
      </template>
    </template>
    
    <template v-else>
      <!-- Concierge Contract Fields -->
      <PFRow :label="$pgettext('contract.create.label','Template')" size="12x12">
        <PSelectKeyValue :options="searchTemplate" :value.sync="form.template" placeholder="Select Template"/>
      </PFRow>
      <PFRow :label="$pgettext('contract.create.label','Vertical')" size="12x12">
        <PSelectKeyValue :options="searchVertical" :value.sync="form.vertical" placeholder="Select Vertical"/>
      </PFRow>
      <PFRow :label="$pgettext('contract.create.label','Terzo Dominio ( ex Event Owner )')" size="12x12">
        <PSelectKeyValue :options="searchEventOwner" :value.sync="form.event_owner" placeholder="Select Event owner"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Num Photo Included')">
        <CInput v-model="form.plan.num_photo_included" type="number"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Num Max Photo')">
        <CInput v-model="form.plan.num_max_photo" type="number"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Max Participants')">
        <CInput v-model="form.plan.max_participants" type="number"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Extra Photo Price')">
        <CInput v-model="form.plan.extra_photo_price" type="number"/>
      </PFRow>
      <PFRow :label="$pgettext('contract_manager.label', 'Is Promo')">
        <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.plan.is_promo"/>
      </PFRow>
    </template>
    
    <div class="mt-3">
      <CButton color="primary" @click="onSave" v-translate translate-context="form">{{ save_text }}</CButton>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PFRow from "@/domain/core/components/PFRow.vue";
import PSelectKeyValue from "@/domain/core/components/PSelectKeyValue.vue";
import CurrencySelect from "@/domain/core/components/CurrencySelect.vue";

export default {
  name: "ContractForm",
  components: {PSelectKeyValue, PFRow, CurrencySelect},
  props: {
    data: {
      type: Object,
      required: true
    },
    save_text: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['save'],
  data() {
    return {
      form: {...this.data}
    }
  },
  async mounted() {
    await this.searchPlanCategory()
  },
  computed: {
    ...mapGetters('contractManager', [
      'plan_categories',
      'base_plans',
    ]),
    planCategoryOptions() {
      return this.plan_categories || []
    },
    basePlanOptions() {
      return this.base_plans || []
    }
  },
  methods: {
    ...mapActions('contractManager', [
      'searchEventOwner',
      'searchTemplate', 
      'searchVertical',
      'searchPlanCategory',
      'searchBasePlan',
    ]),
    async onSaasToggle(isSaas) {
      if (isSaas) {
        // Reset non-SaaS fields
        this.form.template = null
        this.form.vertical = null
        this.form.event_owner = null
      } else {
        // Reset SaaS fields
        this.form.plan_category = null
        this.form.base_plan = null
        this.form.is_subscription = false
        this.form.event_owner = 34
      }
    },
    async onPlanCategoryChange(categoryId) {
      this.form.base_plan = null // Reset base plan when category changes
      if (categoryId) {
        await this.searchBasePlan(categoryId)
      }
    },
    onSave() {
      this.$emit('save', this.form)
    }
  },
  watch: {
    data: {
      handler(newData) {
        this.form = {...newData}
      },
      deep: true
    }
  }
}
</script>